/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/UIButton")
UIGroupButton = xClass("UIGroupButton", UIButton, function (node) {
    return node
})
UIGroupButton.prototype.ctor = function (node, swallowTouch) {
    var self = this
    UIButton.prototype.ctor.call(self, node, swallowTouch)
    self.downHandler = null
    self.moveInHander = null
    self.moveOutHandler = null
    self.upHandler = null
    self.upOutHandler = null
    self.listening = false
    self.setEvents()
    self.setEnabled(false)
    self.setEnabled(true)
}
UIGroupButton.prototype.setEnabled = function (enabled, ingoreGroup) {
    var self = this
    if (self.enabled === enabled) {
        return 
    }
    UIButton.prototype.setEnabled.call(self, enabled)
    if (!ingoreGroup) {
        var normal = self.getChildByName("normal")
        var click = self.getChildByName("click")
        var disabled = self.getChildByName("disabled")
        if (click) {
            click.setVisible(false)
        }
        if (disabled) {
            if (normal) {
                normal.setVisible(enabled)
            }
            disabled.setVisible(!enabled)
        } else if (normal) {
            normal.setVisible(true)
        }
    }
}
UIGroupButton.prototype.setLabel = function (str) {
    var self = this
    var label = self.getChildByName("label")
    if (label) {
        label.setString(tostring(str))
    }
}
UIGroupButton.prototype.offsetLabel = function (x, y) {
    var self = this
    var label = self.getChildByName("label")
    if (label) {
        var {x: px, y: py} = label.getPosition()
        label.setPosition(px + x, py + y)
    }
}
UIGroupButton.prototype.setEvents = function () {
    var self = this
    function onTouchDown(event) {
        if (self.listening) {
            return 
        }
        self.listening = true
        var normal = self.getChildByName("normal")
        var click = self.getChildByName("click")
        var disabled = self.getChildByName("disabled")
        if (click) {
            if (normal) {
                normal.setVisible(false)
            }
            click.setVisible(true)
        } else if (normal) {
            normal.setVisible(true)
        }
        if (disabled) {
            disabled.setVisible(false)
        }
    }
    function onTouchUp(event) {
        if (!self.listening) {
            return 
        }
        self.listening = false
        var normal = self.getChildByName("normal")
        var click = self.getChildByName("click")
        var disabled = self.getChildByName("disabled")
        if (normal) {
            normal.setVisible(self.enabled)
        }
        if (click) {
            click.setVisible(false)
        }
        if (disabled) {
            disabled.setVisible(!self.enabled)
        }
    }
    var useless;
    [useless, self.downHandler] = self.on(UIButtonEvent.Down, onTouchDown)
    [useless, self.moveInHander] = self.on(UIButtonEvent.MoveIn, onTouchDown)
    [useless, self.upHandler] = self.on(UIButtonEvent.Click, onTouchUp)
    [useless, self.moveOutHandler] = self.on(UIButtonEvent.MoveOut, onTouchUp)
    [useless, self.upOutHandler] = self.on(UIButtonEvent.UpOutside, onTouchUp)
    function playMusic() {
        var __VA_ARG = $slice(arguments, 0)
        // body
        MusicPlayer.playEffect(GameMusicType.kBtnClick)
    }
    self.on(UIButtonEvent.Click, playMusic)
}
